import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getColor } from 'helpers/utils';

export default function SingleBarChart({
  width,
  height,
  title,
  labels,
  dataset,
  dataTotal
}) {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );
  const getTotalSum = dataTotal => {
    return dataTotal.reduce((sum, point) => sum + point);
  };

  const getSumAtDataPoint = dataTotal => {
    let sum = 0;
    return dataTotal.map(value => {
      sum = sum + value;
      return sum;
    });
  };

  const getPercentageAtDataPoint = dataTotal => {
    const cumulativeDataPoint = getSumAtDataPoint(dataTotal);
    if (cumulativeDataPoint && cumulativeDataPoint.length > 0) {
      return cumulativeDataPoint.map(value => {
        return parseFloat((value / getTotalSum(dataTotal)) * 100).toFixed(2);
      });
    }
  };

  const options = {
    reponsive: true,
    plugins: {
      legend: {
        position: 'top',
        display: true,
        labels: {
          filter: function (item) {
            return !item.text.includes('Trend Line');
          }
        }
      },
      title: {
        display: false,
        text: title
      }
    },
    scales: {
      y: {
        stacked: true,
        beginAtzero: true,
        title: {
          display: true,
          text: 'Number Of Frames'
        }
      },
      x: {
        stacked: true,
        ticks: {
          autoSkip: false, // Ensure all labels show
          maxRotation: 90, // Rotate labels 90 degrees
          minRotation: 90 // Ensure full rotation
        }
      },
      percentageAxis: {
        type: 'linear',
        position: 'right',
        beginAtzero: true,
        min: 0,
        max: 100,
        ticks: {
          callback: function (value) {
            return value + '%';
          }
        },
        title: {
          display: true,
          text: 'Cumulative Percentage'
        }
      }
    }
  };

  const data = {
    labels,
    datasets: [
      {
        label: 'Missing Frames Percentage',
        data: getPercentageAtDataPoint(dataTotal),
        borderColor: 'rgba(255,26,104, 0.5)',
        backgroundColor: 'rgba(255,26,104, 1)',
        yAxisID: 'percentageAxis',
        type: 'line'
      },
      {
        label: 'Missing Frames At Days Shift',
        data: dataset.days,
        borderColor: getColor('gray-400'),
        backgroundColor: getColor('gray-400'),
        borderWidth: 1,
        type: 'bar'
      },
      {
        label: 'Missing Frames At Lates Shift',
        data: dataset.lates,
        borderColor: getColor('info'),
        backgroundColor: getColor('info'),
        borderWidth: 1,
        type: 'bar'
      },
      {
        label: 'Missing Frames At Nights Shift',
        data: dataset.nights,
        borderColor: getColor('primary'),
        backgroundColor: getColor('primary'),
        borderWidth: 1,
        type: 'bar'
      }
    ]
  };

  return (
    <Card style={{ width: width, height: height }}>
      <Card.Header>
        <h4 style={{ textAlign: 'center' }}>{title}</h4>
      </Card.Header>
      <Card.Body>
        <Bar options={options} data={data} width={'100%'} height={'100%'} />
      </Card.Body>
    </Card>
  );
}

SingleBarChart.propTypes = {
  title: PropTypes.string,
  labels: PropTypes.array,
  dataset: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  dataTotal: PropTypes.array
};
